<template>
  <a-modal
    v-model="visible"
    :title="$t('device_selectModel_title')"
    :maskClosable="false"
    :closable="!formLoading"
    :okText="$t('com_btn_confirm')"
    width="70%"
    :confirmLoading="formLoading"
    :cancelButtonProps="{
      props: {
        disabled: formLoading,
      },
    }"
    :bodyStyle="{ padding: 0 }"
    centered
  >
    <div class="device-model-main" v-if="list && list.length">
      <div class="device-model-side">
        <!-- 父模型列表 -->
        <ul>
          <li
            v-for="model in list"
            :key="model.devModelId"
            :class="
              currentModel &&
              (currentModel.devModelId === model.devModelId ||
                currentModel.parentId === model.devModelId)
                ? 'open'
                : ''
            "
          >
            <div
              class="mode-list-title"
              :class="
                currentModel && currentModel.devModelId === model.devModelId ? 'open active' : ''
              "
              @click="getModelDetail(model.devModelId)"
            >
              <Icon type="menu_device_model" />
              <!-- <a-icon type="tag" v-else /> -->
              <span
                >{{ model.name
                }}<em style="color:#fff;" v-if="!checkParentWhatHasChildren"> ✓</em></span
              >
            </div>
            <ul v-if="model.children && model.children.length">
              <li v-for="child in model.children" :key="child.devModelId">
                <div
                  class="mode-list-title"
                  @click="getModelDetail(child.devModelId)"
                  :class="
                    currentModel && currentModel.devModelId === child.devModelId ? 'active' : ''
                  "
                >
                  <a-icon type="tag" />
                  <span
                    >{{ child.name
                    }}<em style="color:#fff;" v-if="!checkParentWhatHasChildren"> ✓</em></span
                  >
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="device-model-content">
        <ul v-if="currentModel">
          <li>
            <label>{{ $t('device_selectModel_name_label') }}：</label
            ><span
              ><b>{{ currentModel.name }}</b></span
            >
          </li>
          <li v-if="currentModel.description">
            <label>{{ $t('com_form_description') }}：</label>
            <span>{{ currentModel.description }}</span>
          </li>
          <li style="display:flex;">
            <label>{{ $t('device_selectModel_image_label') }}：</label>
            <span>
              <img
                :src="`${Config.staticURL}${currentModel.icon}`"
                v-if="currentModel.icon"
                style="width:auto;max-width:100%;"
              />
              <Space v-else style="width:70px;height:70px;margin:5px 0 0;" />
            </span>
          </li>
        </ul>
      </div>
    </div>
    <Empty v-else style="height:300px;" />

    <template slot="footer">
      <div style="display: flex;justify-content: space-between;align-items: center;">
        <div class="footer-error">
          <span v-if="checkParentWhatHasChildren" style="color:#f00;">
            <a-icon type="warning" style="margin-right:5px;" />
            {{ $t('device_selectModel_error') }}
          </span>
        </div>
        <div class="footer-button">
          <a-button type="default" @click="cancelSubmit">
            {{ $t('com_btn_cancel') }}
          </a-button>
          <a-button type="primary" @click="confirmSubmit" :disabled="checkParentWhatHasChildren">
            {{ $t('com_btn_confirm') }}
          </a-button>
        </div>
      </div>
    </template>
  </a-modal>
</template>
<script>
import Config from '@/config';

export default {
  props: {
    callback: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      Config,
      // 新增
      visible: false,

      list: [],
      listObject: {},
      currentModel: null,

      formLoading: false,

      checkParentWhatHasChildren: false,

      loading: false,
    };
  },
  methods: {
    // - 显示
    show(modelList, modelId) {
      if (modelList) {
        this.list = modelList.array;
        this.listObject = modelList.object;

        if (modelId) {
          if (this.listObject[modelId]) {
            this.currentModel = this.listObject[modelId];
          }
        } else {
          if (this.list) {
            // 默认取第一个（子集或没有子集的父级）
            if (this.list[0] && this.list[0].children && this.list[0].children.length) {
              this.currentModel = this.list[0].children[0];
            } else {
              this.currentModel = this.list[0];
            }
          }
        }
      }

      this.visible = true;
    },

    // 获取model详情
    getModelDetail(id) {
      this.currentModel = this.listObject[id];

      if (this.currentModel && this.currentModel.children && this.currentModel.children.length) {
        this.checkParentWhatHasChildren = true;
        return false;
      }
      this.checkParentWhatHasChildren = false;
    },

    confirmSubmit() {
      if (this.checkParentWhatHasChildren) {
        return;
      }
      this.callback && this.callback(this.currentModel);
      this.visible = false;
    },

    cancelSubmit() {
      this.visible = false;
    },
  },
};
</script>
<style lang="less" scoped>
.device-model-main {
  display: flex;
  height: 100%;
  .device-model-side {
    width: 220px;
    min-width: 220px;
    padding: 20px 10px;
    box-sizing: border-box;
    border-right: #eee solid 1px;
    overflow-x: hidden;
    overflow-y: auto;

    ul {
      display: block;
      li {
        cursor: pointer;
        margin-bottom: 5px;

        .mode-list-title {
          display: flex;
          align-items: center;
          font-size: 12px;
          padding: 7px;
          color: #666;

          em {
            display: none;
          }

          > svg {
            margin-right: 8px;
          }

          // icon
          .anticon {
            font-size: 18px;
            transform: scale(0.6);
            margin-right: 8px;
          }
          &:not(.active):hover {
            color: #1838d9;
            cursor: pointer;
            background: #f5f5f5;
            border-radius: 5px;
          }

          span {
            display: flex;
            word-break: break-all;
            word-wrap: break-word;
            width: 100%;
            justify-content: space-between;
          }

          &.active,
          &.router-link-exact-active {
            color: #fff;
            background: #1838d9;
            border-radius: 5px;

            span {
              em {
                display: block;
                padding-right: 5px;
              }
            }
          }
        }

        &.open {
          ul {
            display: block;
          }
        }

        ul {
          // display: none;
          display: block;
          li {
            .mode-list-title {
              padding-left: 35px;
            }
          }
        }
      }
    }
  }

  .device-model-content {
    flex: 1;
    padding: 20px;
    li {
      padding: 8px 0;

      label {
        color: #999;
      }

      span {
        flex: 1;
      }
    }
  }

  .model-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
